
import moment from 'moment';
import { container } from 'op/container';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import randomstring from 'randomstring';
import { compose, withState, withHandlers, withProps } from 'recompose';


import { withReportSaving, withReportValidation } from '../report.helper';

export const createReportBase = ({ person_id,hidden_person_id }) => ({ 
	id: randomstring.generate(6),
	person_id:person_id,
	hidden_person_id:hidden_person_id,
	remarks: {},
	timestamp: moment.now(), 
	startTime: moment().format("HH:mm:ss"),
		/* .add(10 - (moment().minute() % 10), 'minutes')
		.subtract(moment().seconds(), 'seconds')
		.format('HH:mm:ss'), */
	completed: false,
	evaluations: [],
	attachments: [],
	signatures: { }
});

export const withReportCreation = compose(
	withState('isCreating', 'setCreating', false),
	withState('isFirstTime', 'setIsFirstTime', true),
	connect(({ person }, { match }) => ({
		person: person.loaded.find(p => p.id.toString() == match.params.person_id),
	})),	
	withProps(({ person }) => (
		{ 
			person_id:person.id ,
			hidden_person_id:person.person_id
		})),
	withState('report', 'setReport', createReportBase),
	withReportValidation,
	withReportSaving,
	withHandlers({
		submitReport: ({ report, online, saveReport, setCreating, setIsFirstTime, dispatch }) => async () => {
			setIsFirstTime(true);
			setCreating(true);

			if (online) {
				const savedReport = await saveReport(false);

				dispatch(container.resolve('actions').save_report(savedReport));
				container.resolve('history').push(`report/${savedReport.id}/edit`)
			} else {
				dispatch(container.resolve('actions').save_report(Object.assign(report, { lastUpdateTime: moment.now() })));
				setTimeout(() => { 
					setCreating(false);
					container.resolve('history').push(`report/${report.id}/edit`);
				}, 200);				
			}
		},
	}),
);
